import React, { useMemo } from 'react';
import { ScrollView, StyleSheet, TouchableOpacity } from 'react-native';
import { Text } from 'react-native-paper';

import { Palette, radius, spacing, useThemePalette } from '../../theme';

export interface SectionItem {
  id: string;
  label: string;
}

interface Props {
  sections: SectionItem[];
  active: string;
  onChange: (id: string) => void;
}

const SectionNav: React.FC<Props> = ({ sections, active, onChange }) => {
  const palette = useThemePalette();
  const styles = useMemo(() => makeStyles(palette), [palette]);

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      style={styles.scroll}
      contentContainerStyle={styles.content}
    >
      {sections.map((s) => {
        const selected = s.id === active;
        return (
          <TouchableOpacity
            key={s.id}
            onPress={() => onChange(s.id)}
            activeOpacity={0.85}
            style={[styles.chip, selected && styles.chipSelected]}
          >
            <Text style={[styles.label, selected && styles.labelSelected]}>
              {s.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </ScrollView>
  );
};

const makeStyles = (p: Palette) =>
  StyleSheet.create({
    scroll: { flexGrow: 0 },
    content: {
      gap: spacing.xs,
      paddingHorizontal: spacing.lg,
      paddingTop: 2,
      paddingBottom: spacing.sm,
    },
    chip: {
      paddingHorizontal: spacing.md,
      paddingVertical: spacing.sm + 1,
      borderRadius: radius.pill,
      backgroundColor: p.surfaceMuted,
      borderWidth: 1,
      borderColor: p.border,
    },
    chipSelected: { backgroundColor: p.appliedBg, borderColor: p.appliedBg },
    label: { color: p.textPrimary, fontSize: 13, fontWeight: '600' },
    labelSelected: { color: p.appliedText, fontWeight: '700' },
  });

export default SectionNav;
